import serviceUrls from 'src/constants/serviceUrls';
import axiosRequest from 'src/helpers/axiosRequest';

export function fetchMessages(id, size, params, config = {}) {
  return axiosRequest(
    'post',
    serviceUrls.NEW_MESSAGING_INBOX_SERVICE,
    {
      pageSize: size || 50,
      pageNumber: 1,
      ...params,
    },
    config,
    null,
    null,
    id,
  );
}

export function getActiveDocumentCount(caseId) {
  return axiosRequest('get', serviceUrls.GET_DASHBOARD_ACTIVE_DOCUMENT_COUNT_SERVICE, {
    isAllData: false.toString(),
    caseId: caseId,
  });
}
